export const LLM_GENERATION_TASK_IDS = {
  DASHBOARD_DRILLDOWN_INSIGHTS_GENERATE: "dashboard.drilldownInsights.generate",
  DASHBOARD_DRILLDOWN_INSIGHTS_STREAM: "dashboard.drilldownInsights.stream",
  AGENT_METRICS_GENERATE: "agent.metrics.generate",
  AGENT_WORKFLOW_GENERATE: "agent.workflow.generate",
  AGENT_WORKFLOW_REGENERATE: "agent.workflow.regenerate",
  IVR_FLOW_GENERATE: "ivr.flow.generate",
  KNOWLEDGE_BASE_SCENARIOS_EXTRACT: "knowledge_base.scenarios.extract",
  METRIC_PROMPT_OPTIMIZE: "metric.prompt.optimize",
  ONBOARDING_METRICS_FROM_TEXT: "onboarding.metrics.fromText",
  ONBOARDING_TEST_CASE_GENERATE: "onboarding.testCase.generate",
  ONBOARDING_TEST_SET_POLISH: "onboarding.testSet.polish",
  TEST_SET_COVERAGE_CHECK: "testSet.coverage.check",
  TEST_SET_COPILOT_STREAM: "testSet.copilot.stream",
  TEST_SET_METADATA_GENERATE: "testSet.metadata.generate",
  TRACE_NATURAL_LANGUAGE_SEARCH_INTERPRET:
    "trace.search.naturalLanguage.interpret",
} as const
